import React, { Component } from 'react';
import ReactModal from '../../components/Modal';

class Actions extends Component {
    constructor(props) {
        super();

        this.onChange = this.onChange.bind(this);
        this.changeView = this.changeView.bind(this);

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);

        this.state = {
            isOpen: false,
            value: props?.defaultValue ?? '',
            showEditMode: props.showOpened ?? false,
        };
    }

    onChange(e) {
        this.setState({ value: e.target.value });
    }

    changeView(bool) {
        this.setState({ showEditMode: bool });
    }

    onOpen() {
        this.setState({
            isOpen: true,
        });
    }

    onClose() {
        this.setState({
            isOpen: false,
        });
    }
    render() {
        const hasValue = !!this.props.customNumber;
        return (
            <>
                {!hasValue ? (
                    <div className={`article-id-alert ${this.props.additionalClassname ?? ''}`}>
                        <span className="article-id-alert__icon">
                            <i className="icon-info-circle" />
                        </span>
                        <span className="article-id-alert__text">
                            <span className="article-id-alert__title">Article ID Position</span>
                            {' — Set your Article ID position to load performance data'}
                        </span>
                        <button
                            type="button"
                            className="article-id-alert__button"
                            id="name-edit-btn"
                            onClick={this.onOpen}
                        >
                            Open Settings
                        </button>
                    </div>
                ) : (
                    <div
                        className={`change-gsc-field-form ${this.props.additionalClassname ?? ''}`}
                    >
                        <button
                            type="button"
                            className="add-cluster-btn gap-8"
                            id="name-edit-btn"
                            onClick={this.onOpen}
                        >
                            <i className="icon-settings1" />
                            {'Article ID Place'}
                            <span>
                                {this.props.customNumber ??
                                    (typeof this?.state?.value === 'string'
                                        ? this?.state?.value?.split(',')?.length
                                        : this?.state?.value?.length) ??
                                    0}
                            </span>
                        </button>
                    </div>
                )}
                {this.state.isOpen && (
                    <ReactModal
                        modalState={this.state.isOpen}
                        className="width-sm article-id-form"
                        onClose={this.onClose}
                    >
                        <div className="article-id-form__header">
                            <h3>Identify Article ID Position</h3>
                            <button
                                type="button"
                                className="article-id-form__close"
                                onClick={this.onClose}
                                aria-label="Close"
                            >
                                <i className="icon-x-close" />
                            </button>
                        </div>
                        <div className="article-id-form-description">
                            <p className="article-id-form__intro">
                                Count the sections of the URL after the domain name to find where
                                the Article ID is located.
                            </p>

                            <div className="article-id-form__section">
                                <div className="article-id-form__section-title">How to count</div>
                                <p className="article-id-form__section-text">
                                    Start counting after the first slash (/) after the domain. Count
                                    every word or number until you reach the ID.
                                </p>
                            </div>

                            <div className="article-id-form__section">
                                <div className="article-id-form__section-title">Example</div>
                                <div className="article-id-form__example">
                                    https://www.domain.com/article/2941619/some-article-slug-name
                                </div>
                                <ul className="article-id-form__list">
                                    <li>
                                        <strong>article</strong> = Position 1
                                    </li>
                                    <li>
                                        <strong>2941619</strong> = Position 2 (This is the ID) ✅
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <form onSubmit={(e) => this.props.onSubmit(e, this.state.value)}>
                            <div className="article-id-form__footer">
                                <div className="article-id-form__field">
                                    <label>Enter position number</label>
                                    <input
                                        name="form-input w-100"
                                        className="form-control"
                                        type="number"
                                        placeholder="e.g. 2"
                                        value={this.state.value}
                                        onChange={this.onChange}
                                    />
                                </div>
                                <button
                                    className="button button-filled button-primary width-sm btn"
                                    style={{ lineHeight: 'unset' }}
                                >
                                    {'Submit'}
                                </button>
                            </div>
                        </form>
                    </ReactModal>
                )}
            </>
        );
    }
}

export default Actions;
